module.exports = __webpack_public_path__ + "static/media/40.7748ae15.jpg";